/**
 * ================================================================================
 * SHIPPING CALCULATOR - JavaScript Module
 * ================================================================================
 * 
 * A modern, accessible dispatch time calculator for Shopify storefronts.
 * Features:
 * - State management (loading, success, empty, error)
 * - Client-side caching with TTL
 * - Smooth transitions and animations
 * - Variant change handling
 * - Accessible announcements
 * 
 * @version 2.0.0
 * @author Senior Frontend Engineer
 * ================================================================================
 */

(function() {
  'use strict';

  // ============================================
  // CONFIGURATION
  // ============================================
  
  const CONFIG = {
    // Google Sheets API settings (can be overridden via data attributes)
    sheetId: '1vbQZsAPwIQMRbjKYrUfLk4LyBNHwzDNeb_0mwxnS27Y',
    apiKey: 'AIzaSyAQWv2jBVw9q4-z_G4AlSFG9YdDh_oxBaY',
    sheetName: 'hoja1',
    range: 'A:Z',
    
    // Caching
    cacheEnabled: true,
    cacheTTL: 30 * 60 * 1000, // 30 minutes in milliseconds
    cacheKey: 'shipping_calc_data',
    
    // UI Settings
    loadingDelay: 300, // Minimum loading display time for better UX
    transitionDuration: 250,
    
    // Column mappings from Google Sheet
    columns: {
      region: 0,
      comuna: 1,
      cost: 2,
      minDays: 3,
      maxDays: 4,
      cutoffTime: 5,
      dispatchDate: 6,
      // Additional columns as needed
      sameDay: 10
    }
  };

  // ============================================
  // COMUNAS DATA (Region to Cities mapping)
  // ============================================
  
  const COMUNAS_BY_REGION = {
    'Antofagasta': [
      'Antofagasta', 'Mejillones', 'Sierra Gorda', 'Taltal', 'Calama',
      'Ollague', 'San Pedro de Atacama', 'Tocopilla', 'Maria Elena'
    ],
    'Araucanía': [
      'Angol', 'Carahue', 'Chol Chol', 'Collipulli', 'Cunco', 'Curacautin',
      'Curarrehue', 'Ercilla', 'Freire', 'Galvarino', 'Gorbea', 'Lautaro',
      'Loncoche', 'Lonquimay', 'Los Sauces', 'Lumaco', 'Melipeuco',
      'Nueva Imperial', 'Padre Las Casas', 'Perquenco', 'Pitrufquen', 'Pucon',
      'Puren', 'Renaico', 'Saavedra', 'Temuco', 'Teodoro Schmidt', 'Tolten',
      'Traiguen', 'Victoria', 'Vilcun', 'Villarrica'
    ],
    'Arica Y Parinacota': ['Arica', 'Camarones', 'General Lagos', 'Putre'],
    'Atacama': [
      'Alto Del Carmen', 'Caldera', 'Chanaral', 'Copiapo', 'Diego de Almagro',
      'Freirina', 'Huasco', 'Tierra Amarilla', 'Vallenar'
    ],
    'Aysén': [
      'Aysen', 'Chile Chico', 'Puerto Cisnes', 'Cochrane', 'Coyhaique',
      'Guaitecas', 'Lago Verde', 'Ohiggins', 'Rio Ibanez', 'Tortel'
    ],
    'Bío - Bío': [
      'Alto Biobio', 'Antuco', 'Arauco', 'Cabrero', 'Canete', 'Chiguayante',
      'Concepcion', 'Contulmo', 'Coronel', 'Curanilahue', 'Florida', 'Hualpen',
      'Hualqui', 'Laja', 'Lebu', 'Los Alamos', 'Los Angeles', 'Lota', 'Mulchen',
      'Nacimiento', 'Negrete', 'Penco', 'Quilaco', 'Quilleco', 'San Pedro de La Paz',
      'San Rosendo', 'Santa Barbara', 'Santa Juana', 'Talcahuano', 'Tirua', 'Tome',
      'Tucapel', 'Yumbel'
    ],
    'Coquimbo': [
      'Andacollo', 'Canela', 'Combarbala', 'Coquimbo', 'Illapel', 'La Higuera',
      'La Serena', 'Los Vilos', 'Monte Patria', 'Ovalle', 'Paiguano', 'Punitaqui',
      'Rio Hurtado', 'Salamanca', 'Vicuna'
    ],
    'Libertador General Bernardo OHiggins': [
      'Chepica', 'Chimbarongo', 'Codegua', 'Coinco', 'Coltauco', 'Donihue',
      'Graneros', 'La Estrella', 'Las Cabras', 'Litueche', 'Lolol', 'Machali',
      'Malloa', 'Marchigue', 'San Francisco de Mostazal', 'Nancagua', 'Navidad',
      'Olivar', 'Palmilla', 'Paredones', 'Peralillo', 'Peumo', 'Pichidegua',
      'Pichilemu', 'Placilla Sexta Region', 'Pumanque', 'Quinta de Tilcoco',
      'Rancagua', 'Rengo', 'Requinoa', 'San Fernando', 'San Vicente de Tagua Tagua',
      'Santa Cruz'
    ],
    'Los Lagos': [
      'Ancud', 'Calbuco', 'Castro', 'Chaiten', 'Chonchi', 'Cochamo',
      'Curaco de Velez', 'Dalcahue', 'Fresia', 'Frutillar', 'Futaleufu',
      'Hualaihue', 'Llanquihue', 'Los Muermos', 'Maullin', 'Osorno', 'Palena',
      'Puerto Montt', 'Puerto Octay', 'Puerto Varas', 'Puqueldon', 'Purranque',
      'Puyehue', 'Queilen', 'Quellon', 'Quemchi', 'Quinchao', 'Rio Negro',
      'San Juan de La Costa', 'San Pablo'
    ],
    'Los Ríos': [
      'Corral', 'Futrono', 'La Union', 'Lago Ranco', 'Lanco', 'Los Lagos',
      'Mafil', 'Mariquina', 'Paillaco', 'Panguipulli', 'Rio Bueno', 'Valdivia'
    ],
    'Magallanes Y La Antartica Chilena': [
      'Antartica', 'Cabo de Hornos', 'Laguna Blanca', 'Puerto Natales', 'Porvenir',
      'Primavera', 'Punta Arenas', 'Rio Verde', 'San Gregorio', 'Timaukel',
      'Torres Del Paine'
    ],
    'Maule': [
      'Cauquenes', 'Chanco', 'Colbun', 'Constitucion', 'Curepto', 'Curico',
      'Empedrado', 'Hualane', 'Licanten', 'Linares', 'Longavi', 'Maule',
      'Molina', 'Parral', 'Pelarco', 'Pelluhue', 'Pencahue', 'Rauco', 'Retiro',
      'Rio Claro', 'Romeral', 'Sagrada Familia', 'San Clemente', 'San Javier',
      'San Rafael', 'Talca', 'Teno', 'Vichuquen', 'Villa Alegre', 'Yerbas Buenas'
    ],
    'Metropolitana de Santiago': [
      'Alhue', 'Buin', 'Calera de Tango', 'Cerrillos', 'Cerro Navia', 'Colina',
      'Conchali', 'Curacavi', 'El Bosque', 'El Monte', 'Estacion Central',
      'Huechuraba', 'Independencia', 'Isla de Maipo', 'La Cisterna', 'La Florida',
      'La Granja', 'La Pintana', 'La Reina', 'Lampa', 'Las Condes', 'Lo Barnechea',
      'Lo Espejo', 'Lo Prado', 'Macul', 'Maipu', 'Maria Pinto', 'Melipilla',
      'Nunoa', 'Padre Hurtado', 'Paine', 'Pedro Aguirre Cerda', 'Penaflor',
      'Penalolen', 'Pirque', 'Providencia', 'Pudahuel', 'Puente Alto', 'Quilicura',
      'Quinta Normal', 'Recoleta', 'Renca', 'San Bernardo', 'San Joaquin',
      'San Jose de Maipo', 'San Miguel', 'San Pedro', 'San Ramon', 'Santiago Centro',
      'Talagante', 'Til Til', 'Vitacura'
    ],
    'Tarapacá': [
      'Camina', 'Colchane', 'Huara', 'Iquique', 'Pica', 'Pozo Almonte'
    ],
    'Valparaíso': [
      'Algarrobo', 'Cabildo', 'La Calera', 'Calle Larga', 'Cartagena', 'Casablanca',
      'Catemu', 'Concon', 'El Quisco', 'El Tabo', 'Hijuelas', 'Isla de Pascua',
      'Juan Fernandez', 'La Cruz', 'La Ligua', 'Limache', 'Llay Llay', 'Los Andes',
      'Nogales', 'Olmue', 'Panquehue', 'Papudo', 'Petorca', 'Puchuncavi', 'Putaendo',
      'Quillota', 'Quilpue', 'Quintero', 'Rinconada', 'San Antonio', 'San Esteban',
      'San Felipe', 'Santa Maria', 'Santo Domingo', 'Valparaiso', 'Villa Alemana',
      'Vina Del Mar', 'Zapallar'
    ],
    'Ñuble': [
      'Bulnes', 'Chillan', 'Chillan Viejo', 'Cobquecura', 'Coelemu', 'Coihueco',
      'El Carmen', 'Ninhue', 'Niquen', 'Pemuco', 'Pinto', 'Portezuelo', 'Quillon',
      'Quirihue', 'Ranquil', 'San Carlos', 'San Fabian', 'San Ignacio', 'San Nicolas',
      'Trehuaco', 'Yungay'
    ]
  };

  // ============================================
  // STATE MANAGEMENT
  // ============================================
  
  const State = {
    LOADING: 'loading',
    SUCCESS: 'success',
    EMPTY: 'empty',
    ERROR: 'error'
  };

  // ============================================
  // CACHE MANAGER
  // ============================================
  
  const CacheManager = {
    /**
     * Get cached data if valid
     * @param {string} key - Cache key
     * @returns {Object|null} - Cached data or null
     */
    get(key) {
      if (!CONFIG.cacheEnabled) return null;
      
      try {
        const cached = sessionStorage.getItem(key);
        if (!cached) return null;
        
        const { data, timestamp } = JSON.parse(cached);
        const now = Date.now();
        
        if (now - timestamp > CONFIG.cacheTTL) {
          sessionStorage.removeItem(key);
          return null;
        }
        
        return data;
      } catch (e) {
        console.warn('[ShippingCalc] Cache read error:', e);
        return null;
      }
    },

    /**
     * Set cache data with timestamp
     * @param {string} key - Cache key
     * @param {Object} data - Data to cache
     */
    set(key, data) {
      if (!CONFIG.cacheEnabled) return;
      
      try {
        const payload = {
          data,
          timestamp: Date.now()
        };
        sessionStorage.setItem(key, JSON.stringify(payload));
      } catch (e) {
        console.warn('[ShippingCalc] Cache write error:', e);
      }
    },

    /**
     * Clear specific cache
     * @param {string} key - Cache key
     */
    clear(key) {
      try {
        sessionStorage.removeItem(key);
      } catch (e) {
        console.warn('[ShippingCalc] Cache clear error:', e);
      }
    }
  };

  // ============================================
  // DATA SERVICE
  // ============================================
  
  const DataService = {
    /**
     * Fetch shipping data from Google Sheets
     * @param {string} sheetId - Google Sheet ID
     * @param {string} apiKey - Google API Key
     * @returns {Promise<Array>} - Sheet data rows
     */
    async fetchSheetData(sheetId, apiKey) {
      const cacheKey = `${CONFIG.cacheKey}_${sheetId}`;
      
      // Check cache first
      const cachedData = CacheManager.get(cacheKey);
      if (cachedData) {
        console.log('[ShippingCalc] Using cached data');
        return cachedData;
      }
      
      const url = `https://sheets.googleapis.com/v4/spreadsheets/${sheetId}/values/${CONFIG.sheetName}!${CONFIG.range}?key=${apiKey}`;
      
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
      const json = await response.json();
      const data = json.values || [];
      
      // Cache the data
      CacheManager.set(cacheKey, data);
      
      return data;
    },

    /**
     * Find shipping info for a specific comuna
     * @param {Array} data - Sheet data
     * @param {string} comuna - Selected comuna
     * @returns {Object|null} - Shipping info or null
     */
    findShippingInfo(data, comuna) {
      if (!data || !comuna) return null;
      
      const row = data.find(r => r[CONFIG.columns.comuna] === comuna);
      
      if (!row) return null;
      
      return {
        region: row[CONFIG.columns.region] || '',
        comuna: row[CONFIG.columns.comuna] || '',
        cost: row[CONFIG.columns.cost] || '',
        minDays: row[CONFIG.columns.minDays] || '',
        maxDays: row[CONFIG.columns.maxDays] || '',
        cutoffTime: row[CONFIG.columns.cutoffTime] || '',
        dispatchDate: row[CONFIG.columns.dispatchDate] || '',
        sameDay: row[CONFIG.columns.sameDay] === 'TRUE'
      };
    }
  };

  // ============================================
  // UI HELPERS
  // ============================================
  
  const UIHelpers = {
    /**
     * Format currency
     * @param {string|number} value - Value to format
     * @returns {string} - Formatted currency
     */
    formatCurrency(value) {
      if (!value) return '--';
      const num = parseInt(value.toString().replace(/\D/g, ''), 10);
      if (isNaN(num)) return value;
      return '$' + num.toLocaleString('es-CL');
    },

    /**
     * Format days range
     * @param {string} min - Minimum days
     * @param {string} max - Maximum days
     * @returns {string} - Formatted range
     */
    formatDaysRange(min, max) {
      if (!min && !max) return '--';
      if (min === max) return min;
      return `${min}-${max}`;
    },

    /**
     * Show template and hide others
     * @param {HTMLElement} container - Container element
     * @param {string} templateName - Template to show
     */
    showTemplate(container, templateName) {
      const templates = container.querySelectorAll('[data-template]');
      templates.forEach(tpl => {
        const name = tpl.dataset.template;
        if (name === templateName) {
          tpl.style.display = '';
          // Trigger animation
          tpl.classList.remove('shipping-calc__slide-up');
          void tpl.offsetWidth; // Force reflow
          tpl.classList.add('shipping-calc__slide-up');
        } else {
          tpl.style.display = 'none';
        }
      });
    },

    /**
     * Update aria-busy state
     * @param {HTMLElement} container - Container element
     * @param {boolean} isBusy - Loading state
     */
    setAriaBusy(container, isBusy) {
      const region = container.querySelector('[aria-live]');
      if (region) {
        region.setAttribute('aria-busy', isBusy.toString());
      }
    },

    /**
     * Announce to screen readers
     * @param {string} message - Message to announce
     */
    announce(message) {
      const announcer = document.createElement('div');
      announcer.setAttribute('role', 'status');
      announcer.setAttribute('aria-live', 'polite');
      announcer.setAttribute('aria-atomic', 'true');
      announcer.className = 'shipping-calc__visually-hidden';
      announcer.textContent = message;
      document.body.appendChild(announcer);
      
      setTimeout(() => {
        document.body.removeChild(announcer);
      }, 1000);
    }
  };

  // ============================================
  // SHIPPING CALCULATOR CLASS
  // ============================================
  
  class ShippingCalculator {
    /**
     * Create a ShippingCalculator instance
     * @param {HTMLElement} element - Container element
     */
    constructor(element) {
      this.element = element;
      this.variant = element.dataset.variant || 'expanded';
      this.productId = element.dataset.productId;
      this.variantId = element.dataset.variantId;
      this.sectionId = element.dataset.sectionId;
      
      // Get config from data attributes or use defaults
      this.sheetId = CONFIG.sheetId;
      this.apiKey = CONFIG.apiKey;
      
      // State
      this.currentState = State.LOADING;
      this.sheetData = null;
      this.selectedRegion = '';
      this.selectedComuna = '';
      
      // Cache DOM references
      this.cacheElements();
      
      // Initialize
      this.init();
    }

    /**
     * Cache DOM element references
     */
    cacheElements() {
      if (this.variant === 'compact') {
        this.container = this.element.querySelector('.shipping-calc--compact');
        this.contentEl = this.element.querySelector('.shipping-calc__content');
      } else {
        this.container = this.element.querySelector('.shipping-calc--expanded');
        this.headerEl = this.element.querySelector('.shipping-calc__header--expanded');
        this.bodyEl = this.element.querySelector('.shipping-calc__body');
        this.resultContainer = this.element.querySelector('.shipping-calc__result-container');
        this.regionSelect = this.element.querySelector('[name="region"]');
        this.comunaSelect = this.element.querySelector('[name="comuna"]');
      }
      
      this.retryBtn = this.element.querySelector('.shipping-calc__retry-btn');
    }

    /**
     * Initialize the calculator
     */
    async init() {
      this.bindEvents();
      
      if (this.variant === 'compact') {
        // Compact variant: Load data immediately
        await this.loadInitialData();
      } else {
        // Expanded variant: Show empty state initially
        this.setState(State.EMPTY);
      }
    }

    /**
     * Bind event listeners
     */
    bindEvents() {
      // Retry button
      if (this.retryBtn) {
        this.retryBtn.addEventListener('click', () => this.retry());
      }
      
      if (this.variant === 'expanded') {
        // Accordion toggle
        if (this.headerEl) {
          this.headerEl.addEventListener('click', () => this.toggleAccordion());
          this.headerEl.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.toggleAccordion();
            }
          });
        }
        
        // Region select
        if (this.regionSelect) {
          this.regionSelect.addEventListener('change', (e) => {
            this.handleRegionChange(e.target.value);
          });
        }
        
        // Comuna select
        if (this.comunaSelect) {
          this.comunaSelect.addEventListener('change', (e) => {
            this.handleComunaChange(e.target.value);
          });
        }
      }
      
      // Listen for variant changes (Shopify)
      document.addEventListener('variant:change', (e) => {
        if (e.detail && e.detail.variant) {
          this.variantId = e.detail.variant.id;
          // Re-fetch if needed (variant may affect shipping)
        }
      });
      
      // Alternative variant change listener
      const form = document.querySelector('form[action*="/cart/add"]');
      if (form) {
        form.addEventListener('change', (e) => {
          if (e.target.name && e.target.name.includes('id')) {
            this.variantId = e.target.value;
          }
        });
      }
    }

    /**
     * Toggle accordion open/closed
     */
    toggleAccordion() {
      const isOpen = this.container.classList.contains('is-open');
      
      if (isOpen) {
        this.container.classList.remove('is-open');
        this.headerEl.setAttribute('aria-expanded', 'false');
        this.bodyEl.setAttribute('aria-hidden', 'true');
      } else {
        this.container.classList.add('is-open');
        this.headerEl.setAttribute('aria-expanded', 'true');
        this.bodyEl.setAttribute('aria-hidden', 'false');
      }
    }

    /**
     * Handle region selection change
     * @param {string} region - Selected region
     */
    handleRegionChange(region) {
      this.selectedRegion = region;
      this.selectedComuna = '';
      
      // Reset comuna select
      if (this.comunaSelect) {
        this.comunaSelect.innerHTML = '<option value="">Select City</option>';
        this.comunaSelect.disabled = !region;
        
        if (region && COMUNAS_BY_REGION[region]) {
          COMUNAS_BY_REGION[region].forEach(comuna => {
            const option = document.createElement('option');
            option.value = comuna;
            option.textContent = comuna;
            this.comunaSelect.appendChild(option);
          });
        }
      }
      
      // Show empty state
      this.setState(State.EMPTY);
    }

    /**
     * Handle comuna selection change
     * @param {string} comuna - Selected comuna
     */
    async handleComunaChange(comuna) {
      if (!comuna) {
        this.setState(State.EMPTY);
        return;
      }
      
      this.selectedComuna = comuna;
      await this.fetchAndDisplayShipping();
    }

    /**
     * Load initial data (for compact variant)
     */
    async loadInitialData() {
      this.setState(State.LOADING);
      
      try {
        this.sheetData = await DataService.fetchSheetData(this.sheetId, this.apiKey);
        
        // For compact variant, we might need a default location or detection
        // For now, show empty state until user interacts
        this.setState(State.EMPTY);
      } catch (error) {
        console.error('[ShippingCalc] Initial data load error:', error);
        this.setState(State.ERROR);
      }
    }

    /**
     * Fetch shipping data and display results
     */
    async fetchAndDisplayShipping() {
      this.setState(State.LOADING);
      
      // Minimum loading time for better UX
      const loadingPromise = new Promise(resolve => 
        setTimeout(resolve, CONFIG.loadingDelay)
      );
      
      try {
        // Fetch data if not already loaded
        if (!this.sheetData) {
          this.sheetData = await DataService.fetchSheetData(this.sheetId, this.apiKey);
        }
        
        // Wait for minimum loading time
        await loadingPromise;
        
        // Find shipping info
        const info = DataService.findShippingInfo(this.sheetData, this.selectedComuna);
        
        if (info) {
          this.displayShippingInfo(info);
          this.setState(State.SUCCESS);
          UIHelpers.announce(`Shipping to ${info.comuna}: ${info.minDays} to ${info.maxDays} business days`);
        } else {
          this.setState(State.EMPTY);
          UIHelpers.announce('No shipping information available for this location');
        }
      } catch (error) {
        console.error('[ShippingCalc] Fetch error:', error);
        this.setState(State.ERROR);
        UIHelpers.announce('Unable to load shipping information');
      }
    }

    /**
     * Display shipping information in the UI
     * @param {Object} info - Shipping info object
     */
    displayShippingInfo(info) {
      const container = this.variant === 'compact' ? this.contentEl : this.resultContainer;
      
      // Update field values
      const fields = {
        'days': UIHelpers.formatDaysRange(info.minDays, info.maxDays),
        'days-range': UIHelpers.formatDaysRange(info.minDays, info.maxDays),
        'label': 'business days',
        'cutoff': info.cutoffTime || '--',
        'cutoff-time': info.cutoffTime || '--',
        'dispatch-date': info.dispatchDate || '--',
        'location': `${info.comuna}, ${info.region}`,
        'cost': UIHelpers.formatCurrency(info.cost)
      };
      
      Object.entries(fields).forEach(([field, value]) => {
        const el = container.querySelector(`[data-field="${field}"]`);
        if (el) {
          el.textContent = value;
        }
      });
      
      // Show/hide cutoff notice
      const cutoffNotice = container.querySelector('[data-field="cutoff-notice"]');
      if (cutoffNotice) {
        cutoffNotice.style.display = info.cutoffTime ? '' : 'none';
      }
    }

    /**
     * Set component state
     * @param {string} state - New state
     */
    setState(state) {
      this.currentState = state;
      
      const container = this.variant === 'compact' ? this.contentEl : this.resultContainer;
      
      if (this.container) {
        this.container.dataset.state = state;
        this.container.classList.toggle('is-success', state === State.SUCCESS);
      }
      
      UIHelpers.setAriaBusy(container, state === State.LOADING);
      UIHelpers.showTemplate(container, state);
    }

    /**
     * Retry loading data
     */
    async retry() {
      // Clear cache
      CacheManager.clear(`${CONFIG.cacheKey}_${this.sheetId}`);
      this.sheetData = null;
      
      if (this.selectedComuna) {
        await this.fetchAndDisplayShipping();
      } else {
        await this.loadInitialData();
      }
    }

    /**
     * Destroy instance and clean up
     */
    destroy() {
      // Remove event listeners if needed
      // This would require storing references to bound handlers
    }
  }

  // ============================================
  // INITIALIZATION
  // ============================================
  
  /**
   * Initialize all shipping calculator instances on the page
   */
  function initShippingCalculators() {
    const calculators = document.querySelectorAll('.shipping-calc');
    
    calculators.forEach(element => {
      // Check if already initialized
      if (element.shippingCalcInstance) return;
      
      // Create instance
      element.shippingCalcInstance = new ShippingCalculator(element);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShippingCalculators);
  } else {
    initShippingCalculators();
  }

  // Re-initialize on Shopify section render
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target;
    const calculators = section.querySelectorAll('.shipping-calc');
    calculators.forEach(element => {
      element.shippingCalcInstance = new ShippingCalculator(element);
    });
  });

  // Expose for external use
  window.ShippingCalculator = ShippingCalculator;
  window.ShippingCalculatorInit = initShippingCalculators;

})();
